const PRESET_EXERCISES = [
  // Chest
  'Barbell Bench Press', 'Dumbbell Bench Press', 'Incline Barbell Bench Press',
  'Incline Dumbbell Bench Press', 'Decline Bench Press', 'Cable Fly', 'Dumbbell Fly',
  'Push Up', 'Dips', 'Machine Chest Press', 'Pec Deck',

  // Back
  'Pull Up', 'Chin Up', 'Barbell Row', 'Dumbbell Row', 'Cable Row', 'Seated Cable Row',
  'Lat Pulldown', 'Face Pull', 'T-Bar Row', 'Deadlift', 'Romanian Deadlift',

  // Shoulders
  'Overhead Press', 'Dumbbell Shoulder Press', 'Arnold Press', 'Lateral Raise',
  'Front Raise', 'Rear Delt Fly', 'Cable Lateral Raise', 'Upright Row', 'Shrug',

  // Biceps
  'Barbell Curl', 'Dumbbell Curl', 'Hammer Curl', 'Incline Dumbbell Curl',
  'Cable Curl', 'Preacher Curl', 'Concentration Curl', 'EZ Bar Curl',

  // Triceps
  'Tricep Pushdown', 'Overhead Tricep Extension', 'Skull Crusher', 'Close Grip Bench Press',
  'Tricep Dips', 'Cable Overhead Tricep Extension', 'Diamond Push Up',

  // Legs
  'Squat', 'Front Squat', 'Hack Squat', 'Leg Press', 'Bulgarian Split Squat',
  'Lunge', 'Romanian Deadlift', 'Leg Curl', 'Leg Extension', 'Calf Raise',
  'Seated Calf Raise', 'Hip Thrust', 'Goblet Squat', 'Nordic Curl', 'Good Morning',

  // Abs
  'Plank', 'Cable Crunch', 'Hanging Leg Raise', 'Ab Wheel Rollout', 'Russian Twist',
  'Sit Up', 'Crunch', 'Decline Sit Up', 'Dragon Flag',

  // Compound
  'Clean and Press', 'Power Clean', 'Snatch', 'Farmers Walk', 'Kettlebell Swing',

  // Cardio / timed
  'Treadmill Walk', 'Treadmill Run', 'Stationary Bike', 'Elliptical', 'Rowing Machine',
];

export const TIMED_EXERCISES = new Set([
  'Plank',
  'Treadmill Walk',
  'Treadmill Run',
  'Stationary Bike',
  'Elliptical',
  'Rowing Machine',
  'Farmers Walk',
]);

export const MUSCLE_KEYS = [
  'chest', 'shoulders', 'biceps', 'triceps', 'abs',
  'quads', 'hamstrings', 'glutes', 'calves', 'back', 'traps',
];

export const MUSCLE_LABELS = {
  en: {
    chest: 'Chest',
    shoulders: 'Shoulders',
    biceps: 'Biceps',
    triceps: 'Triceps',
    abs: 'Abs',
    quads: 'Quads',
    hamstrings: 'Hamstrings',
    glutes: 'Glutes',
    calves: 'Calves',
    back: 'Back',
    traps: 'Traps',
    unassigned: 'Unassigned',
  },
  da: {
    chest: 'Bryst',
    shoulders: 'Skuldre',
    biceps: 'Biceps',
    triceps: 'Triceps',
    abs: 'Mave',
    quads: 'Quad',
    hamstrings: 'Baglår',
    glutes: 'Baller',
    calves: 'Lægge',
    back: 'Ryg',
    traps: 'Trapez',
    unassigned: 'Ikke tildelt',
  },
};

export const EXERCISE_MUSCLES = {
  'Barbell Bench Press': { primary: ['chest'], secondary: ['triceps', 'shoulders'] },
  'Dumbbell Bench Press': { primary: ['chest'], secondary: ['triceps', 'shoulders'] },
  'Incline Barbell Bench Press': { primary: ['chest'], secondary: ['shoulders', 'triceps'] },
  'Incline Dumbbell Bench Press': { primary: ['chest'], secondary: ['shoulders', 'triceps'] },
  'Decline Bench Press': { primary: ['chest'], secondary: ['triceps'] },
  'Cable Fly': { primary: ['chest'], secondary: [] },
  'Dumbbell Fly': { primary: ['chest'], secondary: ['shoulders'] },
  'Push Up': { primary: ['chest'], secondary: ['triceps', 'shoulders'] },
  'Dips': { primary: ['chest'], secondary: ['triceps', 'shoulders'] },
  'Machine Chest Press': { primary: ['chest'], secondary: ['triceps'] },
  'Pec Deck': { primary: ['chest'], secondary: [] },

  'Pull Up': { primary: ['back'], secondary: ['biceps'] },
  'Chin Up': { primary: ['back'], secondary: ['biceps'] },
  'Barbell Row': { primary: ['back'], secondary: ['biceps'] },
  'Dumbbell Row': { primary: ['back'], secondary: ['biceps'] },
  'Cable Row': { primary: ['back'], secondary: ['biceps'] },
  'Seated Cable Row': { primary: ['back'], secondary: ['biceps'] },
  'Lat Pulldown': { primary: ['back'], secondary: ['biceps'] },
  'Face Pull': { primary: ['shoulders'], secondary: ['traps'] },
  'T-Bar Row': { primary: ['back'], secondary: ['biceps'] },
  'Deadlift': { primary: ['back'], secondary: ['hamstrings', 'glutes', 'traps'] },
  'Romanian Deadlift': { primary: ['hamstrings'], secondary: ['glutes', 'back'] },

  'Overhead Press': { primary: ['shoulders'], secondary: ['triceps'] },
  'Dumbbell Shoulder Press': { primary: ['shoulders'], secondary: ['triceps'] },
  'Arnold Press': { primary: ['shoulders'], secondary: ['triceps'] },
  'Lateral Raise': { primary: ['shoulders'], secondary: [] },
  'Front Raise': { primary: ['shoulders'], secondary: [] },
  'Rear Delt Fly': { primary: ['shoulders'], secondary: [] },
  'Cable Lateral Raise': { primary: ['shoulders'], secondary: [] },
  'Upright Row': { primary: ['shoulders'], secondary: ['traps'] },
  'Shrug': { primary: ['traps'], secondary: [] },

  'Barbell Curl': { primary: ['biceps'], secondary: [] },
  'Dumbbell Curl': { primary: ['biceps'], secondary: [] },
  'Hammer Curl': { primary: ['biceps'], secondary: [] },
  'Incline Dumbbell Curl': { primary: ['biceps'], secondary: [] },
  'Cable Curl': { primary: ['biceps'], secondary: [] },
  'Preacher Curl': { primary: ['biceps'], secondary: [] },
  'Concentration Curl': { primary: ['biceps'], secondary: [] },
  'EZ Bar Curl': { primary: ['biceps'], secondary: [] },

  'Tricep Pushdown': { primary: ['triceps'], secondary: [] },
  'Overhead Tricep Extension': { primary: ['triceps'], secondary: [] },
  'Skull Crusher': { primary: ['triceps'], secondary: [] },
  'Close Grip Bench Press': { primary: ['triceps'], secondary: ['chest'] },
  'Tricep Dips': { primary: ['triceps'], secondary: ['chest'] },
  'Cable Overhead Tricep Extension': { primary: ['triceps'], secondary: [] },
  'Diamond Push Up': { primary: ['triceps'], secondary: ['chest'] },

  'Squat': { primary: ['quads'], secondary: ['glutes'] },
  'Front Squat': { primary: ['quads'], secondary: ['glutes'] },
  'Hack Squat': { primary: ['quads'], secondary: ['glutes'] },
  'Leg Press': { primary: ['quads'], secondary: ['glutes'] },
  'Bulgarian Split Squat': { primary: ['quads'], secondary: ['glutes'] },
  'Lunge': { primary: ['quads'], secondary: ['glutes'] },
  'Leg Curl': { primary: ['hamstrings'], secondary: [] },
  'Leg Extension': { primary: ['quads'], secondary: [] },
  'Calf Raise': { primary: ['calves'], secondary: [] },
  'Seated Calf Raise': { primary: ['calves'], secondary: [] },
  'Hip Thrust': { primary: ['glutes'], secondary: ['hamstrings'] },
  'Goblet Squat': { primary: ['quads'], secondary: ['glutes'] },
  'Nordic Curl': { primary: ['hamstrings'], secondary: [] },
  'Good Morning': { primary: ['hamstrings'], secondary: ['back', 'glutes'] },

  'Plank': { primary: ['abs'], secondary: [] },
  'Cable Crunch': { primary: ['abs'], secondary: [] },
  'Hanging Leg Raise': { primary: ['abs'], secondary: [] },
  'Ab Wheel Rollout': { primary: ['abs'], secondary: [] },
  'Russian Twist': { primary: ['abs'], secondary: [] },
  'Sit Up': { primary: ['abs'], secondary: [] },
  'Crunch': { primary: ['abs'], secondary: [] },
  'Decline Sit Up': { primary: ['abs'], secondary: [] },
  'Dragon Flag': { primary: ['abs'], secondary: [] },

  'Clean and Press': { primary: ['shoulders'], secondary: ['quads', 'traps'] },
  'Power Clean': { primary: ['traps'], secondary: ['quads', 'glutes'] },
  'Snatch': { primary: ['shoulders'], secondary: ['quads', 'back'] },
  'Farmers Walk': { primary: ['traps'], secondary: ['abs'] },
  'Kettlebell Swing': { primary: ['glutes'], secondary: ['hamstrings', 'back'] },
};

export function getMuscleLabel(key, language = 'en') {
  const pack = MUSCLE_LABELS[language] || MUSCLE_LABELS.en;
  return pack[key] || key;
}

export function getExerciseMuscles(name, primaryOverride) {
  if (primaryOverride) {
    return { primary: [primaryOverride], secondary: [] };
  }
  if (!name) return { primary: [], secondary: [] };
  if (EXERCISE_MUSCLES[name]) return EXERCISE_MUSCLES[name];
  const lower = String(name).toLowerCase().trim();
  const exact = Object.keys(EXERCISE_MUSCLES).find((k) => k.toLowerCase() === lower);
  if (exact) return EXERCISE_MUSCLES[exact];
  const fuzzy = Object.keys(EXERCISE_MUSCLES).find((k) => {
    const kl = k.toLowerCase();
    return lower.includes(kl) || kl.includes(lower);
  });
  if (fuzzy) return EXERCISE_MUSCLES[fuzzy];
  return { primary: [], secondary: [] };
}

export default PRESET_EXERCISES;
